<template>
  <div>
    <el-form-item label="提示文字">
      <el-input size="small" v-model="value.placeholder" placeholder="请设置提示语"  maxlength="50" show-word-limit/>
    </el-form-item>
    <el-form label-position="top">
      <el-form-item label="选项设置" class="options">
        <div slot="label" class="option-item-label">
          <span>选项名称</span>
          <!-- <el-button icon="el-icon-plus" type="text" size="mini"
                     @click="value.options.push('选项'+(value.options.length+1))">添加选项</el-button> -->
        </div>
        <!-- {{ value }} -->
        <draggable :list="value.options" group="option" handler=".el-icon-rank" :options="dragOption">
          <div v-for="(op, index) in value.options" :key="index" class="option-item">
            <!-- <i class="el-icon-rank"></i> -->
            <el-radio v-if="formName === 'SelectInput'" v-model="radio" :label="index" class="none-label"></el-radio>
            <el-checkbox v-else-if="formName === 'MultipleSelect'"  v-model="checked" :label="index" class="none-label"></el-checkbox>
  
            <div class="icon-move"></div>
            <el-input v-model="value.options[index]" size="small" placeholder="请设置选项值" clearable  maxlength="24" show-word-limit></el-input>
            <!-- <el-button icon="el-icon-delete"  type="text" size="mini"@click="value.options.splice(index, 1)"></el-button> -->
            <div class="icon-delete"  @click="value.options.splice(index, 1)"></div>
          </div>
        </draggable>
        <!-- 按钮 -->
        <div class="btn-content">
          <div class="btn" @click="onEdit">批量编辑</div>
          <div class="btn" @click="value.options.push('选项'+(value.options.length+1))">添加选项</div>
          <!-- <div class="btn">选项关联</div> -->
        </div>

      </el-form-item>
    </el-form>
    <!-- <el-form-item label="选项展开">
      <el-switch v-model="value.expanding"></el-switch>
    </el-form-item> -->
    <popBatchEdit ref="popBatchEdit" @ok="setEdit"></popBatchEdit>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import popBatchEdit from "./popBatchEdit.vue";
export default {
  name: "SelectInputConfig",
  components: {draggable,popBatchEdit},
  props:{
    value:{
      type: Object,
      default: ()=>{
        return {}
      }
    },
    formName:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      radio:'',
      checked:[],
      dragOption:{
        animation: 300,
        sort: true
      }
    }
  },
  methods: {
    // 打开批量编辑
    onEdit(){
       let str = this.value.options.join('\n')
      this.$refs.popBatchEdit.show(str)
    },
    // 设置批量编辑
    setEdit(textarea){
      let arr = textarea.split('\n').filter(item => item.trim() !== '');
      this.value.options = arr
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .options{
  .el-form-item__label{
    display: block;
    width: 100%;
    text-align: left;
  }
  .el-icon-rank{
    padding-right: 5px;
    cursor: move;
  }
  .option-item{
    display: flex;
    .el-input{
      width: 245px;
      float:right;
    }
    .icon-move{
      width: 32px;
      height: 40px;
      background-image: url('~@/pages/officeApproval/common/icon/icon-move-16.png');
      background-size: 16px 16px;
      background-repeat: no-repeat;
      background-position: center center;
      cursor: grab;
    }
    .icon-delete{
      width: 25px;
      height: 40px;
      background-image: url('~@/pages/officeApproval/common/icon/icon-del.png');
      background-size: 16px 16px;
      background-repeat: no-repeat;
      background-position: 7px center;
    }
    // .el-input-group__append{
    //   padding: 0 10px;
    // }
  }
}

.option-item-label{
  height: 30px;
  line-height: 30px;
  button{
    float:right;
  }
}

/*/deep/ .el-form-item {
  margin-bottom: 10px;

  .el-form-item__label {
    padding: 0;
  }
  .options{
    .el-icon-rank{
      cursor: move;
    }
  }
}*/
.none-label /deep/{
  margin-right: 0;
  line-height: 40px;
  .el-checkbox__label,
  .el-radio__label{
    display: none;
  }
}
.btn-content{
  display: flex;
  padding-top: 16px;;
  flex-wrap: wrap;
  gap: 16px;
  // justify-content:space-around;
  .btn{
    height: 32px;
    background: #E4F7F4;
    border-radius: 4px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #00B498;
    // margin-right: 16px;
    padding: 0 12px;
    cursor: pointer;
    &:hover{
      background:#dcf7f3;
    }
  }
}
</style>
